// src/utils/media.js
const MEDIA_BASE = import.meta.env?.VITE_MEDIA_BASE ?? "/media";
const LEGACY_BROKEN_CONTACT_MEDIA_REGEX = /^\/?media\/contact_[^/]+\.(?:jpe?g|png|webp|gif|bmp)$/i;

export function sanitizeLegacyMediaSource(src) {
  if (src === null || src === undefined) return "";
  const value = String(src).trim();
  if (!value) return "";
  if (LEGACY_BROKEN_CONTACT_MEDIA_REGEX.test(value)) {
    return "";
  }
  return value;
}

export function resolveMediaUrl(src) {
  const value = sanitizeLegacyMediaSource(src);
  if (!value) return "";
  if (/^(data:|blob:|file:|https?:\/\/)/i.test(value)) return value;
  if (value.startsWith("/")) return value;
  const base = MEDIA_BASE.replace(/\/$/, "");
  const path = value.replace(/^\//, "").replace(/^media\//, "");
  return `${base}/${path}`;
}
